var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v(_vm._s(_vm.item.fss7Relevant ? _vm.$t("general.yes") : _vm.$t("general.no")))])
}
var staticRenderFns = []

export { render, staticRenderFns }